<template>
  <b-card no-body class="bupadental-getPracticeAreaLeaderboard">
    <b-card-header class="bg-white">
      <strong>Practice Area Leaderboard</strong>
    </b-card-header>
    <b-card-body class="p-0" v-if="loading">
      <div class="d-flex justify-content-center mb-3">
        <b-spinner label="Loading..." type="grow" variant="primary"/>
      </div>
    </b-card-body>
    <b-card-body class="p-0" v-else-if="Array.isArray(items) && items.length">
      <div class="d-flex flex-row align-items-center border-top py-2 px-3" v-for="({ name, total }, i) in items.slice(0, 5)"
        :class="{ 'border-top-0': i === 0 }">
          <span style="min-width: 20px;">
            <template v-if="i === 0 && total > 0">🥇</template>
            <template v-else-if="i === 1 && total > 0">🥈</template>
            <template v-else-if="i === 2 && total > 0">🥉</template>
          </span>
          <span class="flex-fill">{{ name }}</span>
          <span>{{ total }}</span>
      </div>
    </b-card-body>
    <b-card-footer class="bg-white text-center">
      <a href="#" v-b-modal.practiceAreaLeaderboard>View More</a>
    </b-card-footer>

    <b-modal title="Practice Area Leaderboard" id="practiceAreaLeaderboard" body-class="p-0"
      hide-footer lazy scrollable size="xl">
        <b-table striped hover :fields="fields" :items="items">
          <template #cell(id)="{ index: i, item: { total } }">
            <template v-if="i === 0 && total > 0">🥇</template>
            <template v-else-if="i === 1 && total > 0">🥈</template>
            <template v-else-if="i === 2 && total > 0">🥉</template>
          </template>
        </b-table>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    results: {
      type: Object,
    },
  },
  computed: {
    fields() {
      const labels = this.results && this.results.labels ? JSON.parse(this.results.labels) : {};

      return [
        { key: 'id', label: '' },
        { key: 'name' },
        ...(Object.keys(labels).map(label => {
          return {
            key: label.toLowerCase(),
            label,
            formatter(v, k, r) {
              return Object.keys(r).filter(a => labels[label].includes(a)).reduce((s, a) => s + (r[a] || 0), 0);
            },
          };
        })),
        { key: 'total' },
      ];
    },
    items() {
      return this.results && this.results.results ? JSON.parse(this.results.results) : [];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/success/bupadental-practiceAreaLeaderboard.vue